
import {  Link  } from "react-router-dom";

export default function HeroCard2() {
  return (
    <>
      <section className="zen-hero">

        <div className="zen-container">

          {/* LEFT SIDE */}
          <div className="zen-left fadeInUp">
            <h1 className="zen-title slideInLeft">
             Classmock – Build, Teach, Test, Grow<br />
             
            </h1>

            <p className="zen-desc fadeInDelay">
              From online courses and live classes to mock tests, analytics, and student communities — Classmock gives educators everything they need to run modern classes and exam preparation programs without technical complexity.
            </p>

            <Link to="/login"><button className="zen-btn btn-anim">Get started free</button></Link>
          </div>

          {/* RIGHT SIDE */}
          <div className="zen-right">
            <div className="zen-img-wrapper floatUp " style={{border:"12px solid #ffffff",borderRadius:"100px"}}>

              <div className="zen-glow"></div>
             
              <img 
                src="https://i.postimg.cc/NjF4BFVz/red_haired_lady_eyeglasses_holds_books_shows_ok_sign_1_removebg_preview.png"
                alt="hero"
                className="zen-hero-img fadeIn"
              />
             </div> <div className="rotateBorder">
              {/* Floating Tags */}
              <div className="zen-tag tag-courses floatTag1">Courses</div>
<div className="zen-tag tag-website floatTag2">Website Builder</div>
<div className="zen-tag tag-community floatTag3">Community</div>

<div className="zen-tag tag-item4 floatTag4">Live Classes</div>
<div className="zen-tag tag-item5 floatTag5">Mock Tests</div>
<div className="zen-tag tag-item6 floatTag6">Analytics</div>
<div className="zen-tag tag-item7 floatTag7">Certificates</div>
<div className="zen-tag tag-item8 floatTag8">Payments</div>
<div className="zen-tag tag-item9 floatTag9">Mobile App</div>

            </div>
          </div>

        </div>
      </section>

      <style>{`
/* =================== BASE STYLES (same as before) =================== */
.zen-hero {
  padding: 70px 0;
  background: #f5f6fd;
  font-family: "Inter", sans-serif;
  
}

.zen-container {
  width: 90%;
  max-width: 1300px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 50px;
}

/* LEFT */
.zen-left { flex: 1; }

.zen-title {
  font-size: 48px;
  line-height: 1.2;
  font-weight: 800;
  margin-bottom: 20px;
  color: #1a1a1a;
}

.zen-desc {
  font-size: 18px;
  color: #555;
  width: 80%;
  line-height: 1.5;
  margin-bottom: 30px;
}

.zen-btn {
  background: #4d4dff;
  color: white;
  padding: 14px 32px;
  border-radius: 10px;
  font-size: 17px;
  font-weight: 600;
  border: none;
  cursor: pointer;
}

/* RIGHT */
.zen-right {position:relative;
  flex: 1;
  display: flex;
  justify-content: center;
}

.zen-img-wrapper {
  position: relative;
  width: 280px;
  height: auto;overflow:hidden;
  border-radius: 150px;
  border: 14px dashed #fff;
}

.zen-hero-img {
  width: 100%;
  aspect-ratio: 2/3;
  object-fit: cover;
  position: relative;
  z-index: 3;
}

/* Glow */
.zen-glow {
  position: absolute;
  width: 150%;
  height: 150%;
  top: -20%;
  left: -25%;
  background: radial-gradient(circle at 60% 40%, rgba(0, 119, 255, 0.45), rgba(0, 119, 255, 0.1), transparent);
  filter: blur(60px);
  z-index: 1;
  animation: glowPulse 6s ease-in-out infinite;
}

/* Tags */
.zen-tag {
  position: absolute;
  padding: 10px 18px;
  background: white;
  box-shadow: 0 5px 18px rgba(0,0,0,0.12);
  border-radius: 25px;
  font-size: 15px;
  font-weight: 600;
  z-index: 5;
}
/* Top Right */
.tag-courses {
  top: 0;
  right: 0;
  background: #ffe7ef;
}

/* Left Center */
.tag-website {
  top: 10%;
  left: 0;
  transform: translateY(-50%);
  background: #e5f6ff;
}

/* Bottom Right */
.tag-community {
  bottom: 0;
  right: 10%;
  background: #f2ecff;
}

/* Inner spacing cluster */
.tag-item4 { top: 22%; right: 30%; background: #f2ecff; }
.tag-item5 { top: 36%; right: 20%; background: #f2ecff; }
.tag-item6 { top: 10%; right: 10%; background: #f2ecff; }

/* Bottom cluster */
.tag-item7 { bottom: 14%; right: 24%; background: #f2ecff; }

/* Accent but still INSIDE */
.tag-item8 { top: 44%; right: 0; background: #f2ecff; }
.tag-item9 { bottom: 8%; left: 12%; background: #f2ecff; }

/* =================== ANIMATIONS =================== */

/* Fade In */
.fadeIn {
  opacity: 0;
  animation: fadeInAnim 1s ease forwards;
}

@keyframes fadeInAnim {
  0% { opacity: 0; transform: scale(0.97); }
  100% { opacity: 1; transform: scale(1); }
}

/* Fade up */
.fadeInUp {
  opacity: 0;
  animation: fadeUp 1s ease forwards 0.1s;
}
.fadeInDelay {
  opacity: 0;
  animation: fadeUp 1s ease forwards 0.3s;
}

@keyframes fadeUp {
  0% { transform: translateY(30px); opacity: 0; }
  100% { transform: translateY(0); opacity: 1; }
}

/* Slide in from left */
.slideInLeft {
  opacity: 0;
  animation: slideLeft 1s ease forwards;
}

@keyframes slideLeft {
  0% { transform: translateX(-40px); opacity: 0; }
  100% { transform: translateX(0); opacity: 1; }
}

/* Button hover */
.btn-anim {
  transition: transform .25s ease, box-shadow .25s ease;
}
.btn-anim:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 22px rgba(77,77,255,0.25);
}

/* Floating image */
.floatUp {
  animation: floatUpAnim 4.5s ease-in-out infinite;
}

@keyframes floatUpAnim {
  0% { transform: translateY(0); }
  50% { transform: translateY(-12px); }
  100% { transform: translateY(0); }
}

/* Border rotation */
.rotateBorder { position:absolute;top:0px;left:0px;right:0px;bottom:0px;z-index:11;
  animation: rotateBorderAnim 15s linear infinite;
}

@keyframes rotateBorderAnim {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Floating tags */
.floatTag1 { animation: floatTag 10s ease-in-out infinite; }
.floatTag2 { animation: floatTag 11s ease-in-out infinite; }
.floatTag3 { animation: floatTag 12s ease-in-out infinite; }
.floatTag4 { animation: floatTag 13s ease-in-out infinite; }
.floatTag5 { animation: floatTag 14s ease-in-out infinite; }
.floatTag6 { animation: floatTag 15s ease-in-out infinite; }

@keyframes floatTag {
  0% { transform: transform: rotate(0deg);; }
  50% { transform: rotate(-180deg);; }
  100% { transform: rotate(-360deg);; }
}

/* Glow Pulse */
@keyframes glowPulse {
  0% { opacity: 0.7; transform: scale(1); }
  100% { opacity: 1; transform: scale(1.15); }
}

/* Responsive */
@media (max-width: 900px) {
  .zen-container { flex-direction: column; text-align: center; }
  .zen-desc { width: 100%; }
  .zen-right { margin-top: 40px; }
}
      `}</style>
    </>
  );
}
